export enum UserSwipe {
  REJECT = 'reject',
  SELECT = 'select'
}
